import React from 'react';

const SoMeTab = ({ formData, onChange }) => {
    const socialPlatforms = [
        { id: 'facebook', name: 'Facebook', placeholder: 'facebook.com/minside' },
        { id: 'instagram', name: 'Instagram', placeholder: 'instagram.com/minside' },
        { id: 'linkedin', name: 'LinkedIn', placeholder: 'linkedin.com/company/minside' },
        { id: 'tiktok', name: 'TikTok', placeholder: 'tiktok.com/@minside' }
    ];

    const handleUrlChange = (platformId, value) => {
        // Remove any existing protocol
        let cleanUrl = value.replace(/^(https?:\/\/)/, '');
        
        // Add https:// when saving
        const fullUrl = cleanUrl ? `https://${cleanUrl}` : '';
        
        onChange(`socialMedia.${platformId}`, fullUrl);
    };

    const getDisplayUrl = (url) => {
        // Remove protocol for display
        return url ? url.replace(/^(https?:\/\/)/, '') : '';
    };

    return (
        <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-lg font-medium font-montserrat text-gray-900 mb-4">Sociale medier</h2>
            <div className="space-y-4">
                {socialPlatforms.map(platform => (
                    <div key={platform.id}>
                        <label className="block text-sm font-medium text-gray-700">{platform.name}</label>
                        <input
                            type="text"
                            value={getDisplayUrl(formData.socialMedia?.[platform.id])}
                            onChange={(e) => handleUrlChange(platform.id, e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            placeholder={platform.placeholder}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SoMeTab;